import { render, staticRenderFns } from "./TextAndImageThree.vue?vue&type=template&id=009b06c8&scoped=true&"
import script from "./TextAndImageThree.vue?vue&type=script&lang=js&"
export * from "./TextAndImageThree.vue?vue&type=script&lang=js&"
import style0 from "./TextAndImageThree.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TextAndImageThree.vue?vue&type=style&index=1&id=009b06c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009b06c8",
  null
  
)

export default component.exports